import React, { useState } from 'react';
import style from 'styled-components';
import { TextInput } from './TextInput';
import { UseFormRegisterReturn } from 'react-hook-form'; 
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { Data } from 'core/utilities';

interface Props 
{
    name           : string;
    label?         : string;
    placeholder?   : string;
    input          : UseFormRegisterReturn;
    setValue?      : (name : string, value : any) => void;
    setFormErrors? : React.Dispatch<React.SetStateAction<Data>>;
    normalizer?    : (e : React.ChangeEvent<HTMLInputElement>) => void;
    validator?     : (value : string) => string;
}

export const MaskedInput : React.FunctionComponent<Props> = ({ ...props }) => 
{
    const [ masked, setMasked ] = useState(true);
    const type = masked ? 'password' : 'text';

    return (
        <TextInput type={type} {...props}>
            <EyeContainer onClick={() => setMasked(v => !v)}>
                {masked ? <IoEye /> : <IoEyeOff />}
            </EyeContainer>
        </TextInput>
    );
};

const EyeContainer = style.div`
    margin-top: -27px;
    padding-right: 15px;
    float: right;
    cursor: pointer;
    opacity: 0.5;
`;